import { Button, Typography } from "@c4c-web/ui";
import { cn } from "@c4c-web/libs-hooks/libs";
import { PoweredByGoogle } from "@c4c-web/icons";
import type { IAddressMapFooter } from "./map.interface";

export const Footer = (props: IAddressMapFooter): JSX.Element => {
  const {
    formattedAddress,
    handleDeliveryClick,
    isAddressSelected,
    isAreaSupported,
    t,
  } = props;

  return isAddressSelected ? (
    <>
      <div className="mb-4 text-left">
        <Typography
          className={cn(
            "text-sm md:text-md",
            isAreaSupported === false ? "text-red-400" : "text-black",
          )}
        >
          {t("addressJourney.deliverToLocation")}
        </Typography>
        <Typography
          className={cn(
            "text-md md:text-lg",
            isAreaSupported === false ? "text-red-400" : "text-black",
          )}
          weight="bold"
        >
          {formattedAddress}
        </Typography>
      </div>
      <Button
        className="w-full"
        disabled={!isAreaSupported}
        onClick={handleDeliveryClick}
        size="lg"
        variant="primary"
      >
        {t("addressJourney.yesDeliverToThisLocation")}
      </Button>
    </>
  ) : (
    <div className="flex w-full justify-center">
      <PoweredByGoogle
        className="stroke-0"
        height={25}
        size="custom"
        width={182}
      />
    </div>
  );
};
